function getUrl(obj){
    if (obj){
        return obj.url
    }
    return "";
}
export {
    getUrl
}
